import { Text } from '@chakra-ui/react';

export const DOTS = '...';

export const PaginationDots = () => (
  <Text
    as="span"
    color="gray.4"
    fontSize={{ base: 'xs', md: 'md' }}
    fontWeight={{ base: 'medium', md: 'bold' }}
    m={{ base: 'space.4', md: 'space.8' }}
  >
    {DOTS}
  </Text>
);
